<template>
    <b-card class="numero-blackfon bg-dark text-white mt-3 mb-3">

        <b-row class="usuario-numeroblackfon" align-v="center" justify-h="between">

            <b-col cols="auto">
                <b-button-group size="sm" v-if="!justIndex">
                    <b-button v-if="canBeReloaded" @click.stop="portalCautivo(item)" variant="primary">
                        <!-- <span class="imoon-cart"></span>  -->
                        Recargar
                    </b-button>
                    <b-button v-else @click.stop="portalCautivo(item)" variant="primary">
                        <span class="imoon-credit-card"></span>
                        Requiere suscripción
                    </b-button>
                </b-button-group>

                <b-button v-if="canBeReloaded" class="toggler" @click.stop="toggled = (toggled === item.id ? null : item.id)"  size="sm"
                    :variant="toggled === item.id ? 'secondary' : 'primary'">
                    <i :class="toggled === item.id ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                </b-button>
            </b-col>

            <b-col>

                <strong>
                    {{ item.msisdn | msisdnToPhone }}
                </strong>

                <div class="uppercase block">
                    <b v-if="item.alias" title="Alias de usuario" class="alias">
                        {{ item.alias | uppercase }}
                    </b>
                    
                    <template v-if="item.stripe_suscripcion_id && !justIndex">
                        <b class="plan-name">
                            {{ item.planName }} 
                            <span class="text-primary">{{ item.precio | currency }}</span>
                            <span v-b-tooltip.hover :title='"ID de suscripción: " + item.stripe_suscripcion_id'><i class="fa fa-info-circle"></i></span>
                        </b>
                        <!-- <template v-if="!hideEstatusDN">
                            <small>Estatus: {{ item.estatus_msisdn }}</small>
                        </template> -->
                    </template>
                    <template v-else-if="!item.byPass">
                        <div class="uppercase">
                            <span class="unsuscribed text-nowrap">
                                Activar suscripción
                            </span>
                            <!-- <template v-if="!hideEstatusDN">
                                <small>Estatus: {{ item.estatus_msisdn }}</small>
                            </template> -->
                        </div>
                    </template>
                </div>
            </b-col>

        </b-row>

        <template v-if="toggled == item.id">

            <b-card class="special mt-4">
                <account-saldo-page v-if="item.stripe_suscripcion_id || parseInt(item.byPass)" 
                    :msisdn="item.msisdn"
                    hide-historial-button 
                    hide-number-spinner />
            </b-card>

        </template>

    </b-card>
</template>

<script>
import {portalCautivo as portalCautivoOpener} from '@/js/apiConfig'
import accountSaldoPage from './account-saldo-page.vue';
export default {
    name: 'numeroBlackfon',
    components: {
        accountSaldoPage
    },
    props: {
        justIndex: {
            type: Boolean,
            default: false
        },
        autoclick: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            required: true
        },
        // hideEstatusDN: {
        //     type: Boolean,
        //     default: false
        // }
    },
    computed: {
        canBeReloaded() {
            return this.item.stripe_suscripcion_id || parseInt(this.item.byPass);
        }
    },
    data: () => {
        return {
            toggled: null
        }
    },
    methods: {
		portalCautivo(item){
			portalCautivoOpener(item.msisdn)
		},
    },
    beforeMount() {
        if (this.autoclick && this.canBeReloaded) {
            this.$nextTick(() => {
                this.toggled = this.item.id;
                this.$emit('handleMSISDN', this.item);
            });
        }
    }
}
</script>

<style lang="scss">
.numero-blackfon {
    // Add your styles here
}
</style>